import { PublishedTaskEditorTask } from "./taskEditorRuntime";

export interface TaskEditorListSection {
  key: string;
  label: string;
  setNumber?: number;
  tasks: PublishedTaskEditorTask[];
}

function compareTaskEditorTasks(
  left: PublishedTaskEditorTask,
  right: PublishedTaskEditorTask
) {
  const titleCompare = left.title.localeCompare(right.title, "ko");

  if (titleCompare !== 0) {
    return titleCompare;
  }

  return left.taskId.localeCompare(right.taskId, "ko");
}

export function getTaskEditorSetSectionLabel(setNumber?: number) {
  return typeof setNumber === "number" ? `SET ${setNumber}` : "미분류";
}

export function buildTaskEditorListSections(
  tasks: PublishedTaskEditorTask[]
): TaskEditorListSection[] {
  if (!Array.isArray(tasks)) {
    return [];
  }

  const groupedTasks = new Map<string, TaskEditorListSection>();

  tasks.forEach((task) => {
    if (!task) {
      return;
    }

    const key =
      typeof task.setNumber === "number" ? `set-${task.setNumber}` : "unset";
    const existingSection = groupedTasks.get(key);

    if (existingSection) {
      existingSection.tasks.push(task);
      return;
    }

    groupedTasks.set(key, {
      key,
      label: getTaskEditorSetSectionLabel(task.setNumber),
      setNumber: task.setNumber,
      tasks: [task],
    });
  });

  return Array.from(groupedTasks.values())
    .map((section) => ({
      ...section,
      tasks: [...section.tasks].sort(compareTaskEditorTasks),
    }))
    .sort((left, right) => {
      if (left.setNumber === undefined) {
        return right.setNumber === undefined ? 0 : 1;
      }

      if (right.setNumber === undefined) {
        return -1;
      }

      return left.setNumber - right.setNumber;
    });
}